import script from "./UsersViewForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersViewForm.vue?vue&type=script&setup=true&lang=ts"

import "./UsersViewForm.vue?vue&type=style&index=0&id=16118492&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16118492"]])

export default __exports__